import type { SagaReturnType } from 'redux-saga/effects';
import { takeEvery, select, put } from 'redux-saga/effects';

import { api } from 'src/api';
import { VALIDATE_TOURIST_ON_SERVER } from '../../routes/Checkout/store/constants/tourists';

import { getPackageId } from '../../routes/Checkout/store/selectors/package';
import { touristsValidationPayloadSelector } from './selectors';

import {
  setFetchStatusFailed,
  setFetchStatusLoading,
  setValidate,
} from './slice';
import type { touristsValidateResponse } from './types';

export function* validateTourist() {
  try {
    const packageId: SagaReturnType<typeof getPackageId> = yield select(
      getPackageId,
    );
    const tourists: SagaReturnType<typeof touristsValidationPayloadSelector> =
      yield select(touristsValidationPayloadSelector);

    yield put(setFetchStatusLoading());

    const response: touristsValidateResponse = yield api.postTouristsValidate({
      tourists,
      package_id: packageId,
    });
    yield put(setValidate(response));
  } catch (error) {
    yield put(setFetchStatusFailed());
    // eslint-disable-next-line
    console.log(error);
  }
}

function* saga() {
  yield takeEvery(VALIDATE_TOURIST_ON_SERVER, validateTourist);
}

export default saga;
